import { render, staticRenderFns } from "./FestivalModule.vue?vue&type=template&id=5bbbf403&"
import script from "./FestivalModule.vue?vue&type=script&lang=js&"
export * from "./FestivalModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbbf403')) {
      api.createRecord('5bbbf403', component.options)
    } else {
      api.reload('5bbbf403', component.options)
    }
    module.hot.accept("./FestivalModule.vue?vue&type=template&id=5bbbf403&", function () {
      api.rerender('5bbbf403', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/festivals/FestivalModule.vue"
export default component.exports